import { BRAND_COLORS } from '@/config/appBrand'

export const DEFAULT_PRIMARY = BRAND_COLORS.primary
export const DEFAULT_FAVICON = '/img/icons/favicon-196.png'

function parseHexColor(color) {
  if (!color || typeof color !== 'string') return null
  const hex = color.trim().replace('#', '')
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return null
  return {
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16),
  }
}

function getLuminance({ r, g, b }) {
  const channels = [r, g, b].map((value) => {
    const channel = value / 255
    return channel <= 0.03928
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4)
  })
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2]
}

export function isLightBackground(color) {
  const rgb = parseHexColor(color)
  if (!rgb) return false
  return getLuminance(rgb) > 0.45
}

export function getContrastColors(backgroundColor) {
  const light = isLightBackground(backgroundColor)
  return {
    text: light ? '#111827' : '#FFFFFF',
    textMuted: light ? 'rgba(17, 24, 39, 0.65)' : 'rgba(255, 255, 255, 0.65)',
    textSubtle: light ? 'rgba(17, 24, 39, 0.5)' : 'rgba(255, 255, 255, 0.5)',
    icon: light ? '#111827' : '#FFFFFF',
    border: light ? 'rgba(17, 24, 39, 0.12)' : 'rgba(255, 255, 255, 0.12)',
    buttonBg: light ? 'rgba(17, 24, 39, 0.08)' : 'rgba(255, 255, 255, 0.08)',
    buttonBgHover: light ? 'rgba(17, 24, 39, 0.14)' : 'rgba(255, 255, 255, 0.15)',
    syncBg: light ? 'rgba(17, 24, 39, 0.06)' : 'rgba(0, 0, 0, 0.25)',
    accent: BRAND_COLORS.primary,
  }
}

export function resolveBranding(branding) {
  const primary = branding?.primaryColor || DEFAULT_PRIMARY
  const appBarColor = branding?.appBarColor || BRAND_COLORS.appBar
  return {
    primaryColor: primary,
    appBarColor,
    logo: branding?.logo || null,
    contrast: getContrastColors(appBarColor),
  }
}

export function setFavicon(href) {
  if (typeof document === 'undefined' || !href) return
  const iconHref = href
  let link = document.getElementById('app-favicon')
  if (!link) {
    link = document.createElement('link')
    link.id = 'app-favicon'
    link.rel = 'icon'
    link.type = 'image/png'
    document.head.appendChild(link)
  }
  link.href = iconHref
}

export function applyBrandingSideEffects(branding) {
  const resolved = resolveBranding(branding)
  if (resolved.logo) {
    setFavicon(resolved.logo)
  }
  return resolved
}

export function applyVuetifyTheme(vuetify, branding) {
  const theme = vuetify?.framework?.theme || vuetify?.theme
  if (!theme?.themes?.light) return
  const resolved = resolveBranding(branding)
  theme.setTheme('light', {
    primary: resolved.primaryColor,
    appBar: resolved.appBarColor
  })
}

export function getPersistedLogo() {
  try {
    const raw = sessionStorage.getItem('vuex')
    if (raw) {
      const state = JSON.parse(raw)
      const branding = state?.User?.tenantBranding
      if (branding?.logo) {
        return branding.logo
      }
    }
  } catch (e) {
    // ignore parse errors
  }
  return null
}
